<div id="mkSideBar" class="mk-side-bar" (click)="autoSet('mkSideBar', '220px')">
  <!-- Tool Bar -->
  <app-matrix-top-bar
    [mkSideBar]="mkSideBar"
    [selectedBook]="selectedBook"
    [selectedCylinder]="selectedCylinder"
    [selectedMasterKey]="selectedMasterKey"
    [selectedTab]="selectedTab"
    (action)="saveMatrix()"
  >
  </app-matrix-top-bar>

  <!-- Matrix -->
  <app-key-bitting-matrix
    *ngIf="mkSideBar.show && selectedTab.id === 0 && selectedMasterKey && keySystem"
    [selectedMasterKey]="selectedMasterKey"
    [keySystem]="keySystem"
    [structure]="structure"
    (matrixUpdates)="updateRequest($event)"
    (disableWriteBook)="disableWriteBookBtn($event)"
  >
  </app-key-bitting-matrix>

  <app-cylinder-pinning-matrix
    *ngIf="mkSideBar.show && selectedTab.id === 1 && selectedCylinder"
    [structure]="structure"
    [selectedMasterKey]="selectedMasterKey"
    [keySystem]="keySystem"
    [selectedCylinder]="selectedCylinder"
    (selectedKeyWayId)="updateKeyWayId($event)"
  >
  </app-cylinder-pinning-matrix>

  <app-special-function-keys
    *ngIf="mkSideBar.show && selectedTab.id === 1 && !selectedCylinder"
    [structure]="structure"
    [selectedMasterKey]="selectedMasterKey"
    [keySystem]="keySystem"
    (addKey)="addKey.emit($event)"
    (removeKey)="removeKey.emit($event)"
  >
  </app-special-function-keys>

  <app-construction-key-matrix
    *ngIf="mkSideBar.show && selectedTab.id === 2"
    [selectedMasterKey]="selectedMasterKey"
    [structure]="structure"
    [keySystem]="keySystem"
  >
  </app-construction-key-matrix>

  <!-- Library -->
  <div
    *ngIf="mkSideBar.show && selectedTab.id === 0 && matrix && !selectedBook && !loading.isLoading"
    class="row footer flex-end"
  >
    <div class="col">
      <div class="row flex-end">
        <!-- <phx-button
          class="margin top right bottom left"
          [color]="'#393E46'"
          [outline]="false"
          [small]="true"
          [disabled]="writeBookBtn"
          (document:keydown.shift.s)="hotkey('s1')"
          (click)="validateAndGenerateBook()"
        >
          Write Book
        </phx-button> -->
        <button
          mat-flat-button
          class="margin top right bottom left darkBackground"
          [disabled]="writeBookBtn"
          (document:keydown.shift.s)="hotkey('s1')"
          (click)="validateAndGenerateBook()"
        >
          Write Book
        </button>
      </div>
    </div>
  </div>

  <!-- Selected Book -->
  <div *ngIf="mkSideBar.show && selectedTab.id === 0 && matrix && selectedBook" class="row footer">
    <div class="col">
      <div class="row flex-start">
        <!-- <phx-button
          class="margin top bottom left"
          style="justify-self: flex-start"
          [color]="'#EE6352'"
          *ngIf="selectedBook"
          [outline]="false"
          [small]="true"
          (click)="confirmDelete()"
        >
          Delete
        </phx-button> -->

        <button
          mat-flat-button
          class="margin sml top bottom left orangeBackground"
          style="justify-self: flex-start"
          *ngIf="selectedBook"
          (click)="confirmDelete()"
        >
          Delete
        </button>
      </div>
    </div>

    <div class="col">
      <div class="row flex-end">
        <!-- <phx-button
          [disabled]="assignedMasterKeyBittings.length === 0"
          (document:keydown.shift.c)="hotkey('c')"
          (click)="cancel()"
          [outline]="assignedMasterKeyBittings.length > 0"
          [small]="true"
          *ngIf="selectedBook"
          class="margin top bottom left"
        >
          Cancel
        </phx-button> -->

        <button
          mat-flat-button
          [disabled]="assignedMasterKeyBittings.length === 0"
          (document:keydown.shift.c)="hotkey('c')"
          (click)="cancel()"
          *ngIf="selectedBook"
          class="margin sml top bottom left darkBackground"
        >
          Cancel
        </button>

        <!-- <phx-button
          [disabled]="assignedMasterKeyBittings.length === 0"
          class="margin top right bottom left"
          [color]="'#393E46'"
          *ngIf="selectedBook"
          [outline]="false"
          [small]="true"
          (document:keydown.shift.s)="hotkey('s2')"
          (click)="saveBook()"
        >
          Save Book
        </phx-button> -->
        <button
          mat-flat-button
          [disabled]="assignedMasterKeyBittings.length === 0"
          class="margin sml all darkBackground"
          *ngIf="selectedBook"
          (document:keydown.shift.s)="hotkey('s2')"
          (click)="saveBook()"
        >
          Save Book
        </button>
      </div>
    </div>
  </div>

  <!-- Cylinders -->
  <div class="row footer padding all" *ngIf="mkSideBar.show && selectedTab.id === 1 && selectedCylinder">
    <div class="col">
      <div class="row" justify="flex-start">
        <button
          mat-flat-button
          class="margin top right bottom left darkBackground"
          *ngIf="selectedCylinder && user.isSuperUser"
          [color]="'#EE6352'"
          (click)="confirmDelete()"
        >
          Delete
        </button>
        <!-- <phx-button
          *ngIf="selectedCylinder && user.isSuperUser"
          [color]="'#EE6352'"
          [outline]="false"
          [small]="true"
          (click)="confirmDelete()"
        >
          Delete
        </phx-button> -->
      </div>
    </div>

    <div class="col" *ngIf="isDefaultCrossKeyedCylinder()">
      <div class="row flex-end">
        <button
          mat-flat-button
          class="margin top right bottom left darkBackground"
          [disabled]="writeBookBtn || !enablePrepareForMECS || selectedCylinder?.requiredPinningGeneration"
          (click)="prepareForMecs()"
          [color]="'#393E46'"
        >
          Prepare for MECS
        </button>
        <!-- <phx-button
          [disabled]="!enablePrepareForMECS"
          (click)="prepareForMecs()"
          [color]="'#393E46'"
          [outline]="false"
          [small]="true"
          class="margin left"
        >
          Prepare for MECS
        </phx-button> -->
      </div>
    </div>
  </div>
</div>
